import styled from "@emotion/styled";

export const CloseButton = styled.button<{
  width: number;
  height: number;
  fontSize: number;
  left: number;
  top: number;
}>`
  border: none;
  background-color: white;
  border-radius: 100%;
  height: ${({ height }) => height}px;
  width: ${({ width }) => width}px;
  color: black;
  font-size: ${({ fontSize }) => fontSize}px;
  position: absolute;
  left: ${({ left }) => left}px;
  top: ${({ top }) => top}px;
  z-index: 100;
`;
